import React from 'react';
import Skeleton from '@/components/ui/Skeleton';

const StripeCheckoutSkeleton = () => {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-gradient-to-br from-[#18122b] via-[#2a1a4d] to-[#6A3683]/80 rounded-2xl border border-[#A45DE8]/40 shadow-[0_0_24px_#A45DE8]/20 p-6 md:p-8 max-w-md w-full mx-auto">
        {/* Mystical Header */}
        <div className="text-center mb-6">
          <div className="flex justify-center mb-4">
            <Skeleton className="w-12 h-12 md:w-16 md:h-16 rounded-full" />
          </div>
          <Skeleton className="h-6 md:h-8 w-40 md:w-48 mx-auto mb-2" />
          <Skeleton className="h-3 md:h-4 w-56 md:w-64 mx-auto" />
        </div>
        
        {/* Loading Animation */}
        <div className="flex justify-center mb-6">
          <div className="relative">
            <div className="w-10 h-10 md:w-12 md:h-12 border-4 border-[#A45DE8]/20 border-t-[#A45DE8] rounded-full animate-spin"></div>
            <div className="absolute inset-0 w-10 h-10 md:w-12 md:h-12 border-4 border-transparent border-t-[#D4B6FF]/40 rounded-full animate-spin" style={{ animationDelay: '-0.5s' }}></div>
          </div>
        </div>
        
        {/* Progress Steps */}
        <div className="space-y-3 mb-6">
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-[#A45DE8] flex items-center justify-center">
              <span className="text-white text-xs">✓</span>
            </div>
            <Skeleton className="h-3 md:h-4 w-28 md:w-32" />
          </div>
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 md:w-6 md:h-6 rounded-full border-2 border-[#A45DE8] flex items-center justify-center">
              <div className="w-1.5 h-1.5 md:w-2 md:h-2 bg-[#A45DE8] rounded-full animate-pulse"></div>
            </div>
            <Skeleton className="h-3 md:h-4 w-36 md:w-40" />
          </div>
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 md:w-6 md:h-6 rounded-full border-2 border-[#6A3683]"></div>
            <Skeleton className="h-3 md:h-4 w-32 md:w-36" />
          </div>
        </div>
        
        {/* Mystical Message */}
        <div className="text-center">
          <p className="text-[#D4B6FF] text-xs md:text-sm font-marcellus" style={{ fontFamily: 'var(--font-marcellus), serif' }}>
            Preparing your sacred journey...
          </p>
        </div>
      </div>
    </div>
  );
};

export default StripeCheckoutSkeleton; 